import {
  ChartCurve,
  ChartHorizontalAlign,
  ChartPosition,
  ChartShape
} from '@base/@types/components/Layout/Graphic/Info'
import { IGraphicResponse } from '@base/@types/providers/Kpi/LogisticProvider'

const getDescriptionMonth = (month: number) => {
  switch (month) {
    case 0:
      return 'Jan'
    case 1:
      return 'Fev'
    case 2:
      return 'Mar'
    case 3:
      return 'Abr'
    case 4:
      return 'Mai'
    case 5:
      return 'Jun'
    case 6:
      return 'Jul'
    case 7:
      return 'Ago'
    case 8:
      return 'Set'
    case 9:
      return 'Out'
    case 10:
      return 'Nov'
    case 11:
      return 'Dez'
    default:
      return null
  }
}

export const getStorageSeries = (data: IGraphicResponse) => {
  return [
    {
      name: 'Desvio Médio',
      type: 'line',
      data: data.desvioMedio.map(item => item.valor)
    },
    {
      name: '',
      type: 'line',
      data: []
    }
  ]
}

export const storageOptions = (data: IGraphicResponse) => {
  const option = {
    chart: {
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 10,
        left: 7,
        blur: 8,
        opacity: 0.2
      },
      toolbar: {
        show: true,
        offsetY: -5,
        offsetX: -26
      }
    },
    colors: ['#3b8f30', 'transparent'],
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: [3],
      curve: ChartCurve.smooth,
      colors: ['#3b8f30']
    },
    markers: {
      size: 3,
      strokeWidth: 0,
      shape: ChartShape.circle,
      hover: {
        size: 6
      }
    },
    xaxis: {
      labels: {
        rotate: 0
      },
      categories: data.desvioMedio.map(item => {
        const month = new Date(item.data).getMonth()
        const year = new Date(item.data).getFullYear()

        return `${getDescriptionMonth(month)} ${year}`
      })
    },
    yaxis: {
      title: {
        text: 'Dias'
      },
      tickAmount: 6,
      labels: {
        formatter: function (val: any) {
          return Number(val).toFixed(1)
        }
      }
    },
    tooltip: {
      shared: true,
      y: [
        {
          formatter: function (y: any) {
            return `${Number(y).toFixed(2).replace('.', ',')} Dias`
          }
        }
      ]
    },
    legend: {
      floating: true,
      position: ChartPosition.top,
      horizontalAlign: ChartHorizontalAlign.center,
      offsetX: 25,
      offsetY: -3
    }
  }
  return option
}
